import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { cn } from '@/lib/utils';
import { useUIStore } from '@/stores/uiStore';
import { useIsMobile } from '@/hooks/useMediaQuery';

export function MainLayout() {
  const { sidebarOpen, hideSidebar, setIsMobile } = useUIStore();
  const isMobile = useIsMobile();

  useEffect(() => {
    setIsMobile(isMobile);
  }, [isMobile, setIsMobile]);

  return (
    <div className="min-h-screen bg-background">
      {!hideSidebar && <Sidebar />}
      <main
        className={cn(
          'min-h-screen transition-all duration-300',
          !hideSidebar && (sidebarOpen ? 'ml-64' : 'ml-16'),
          (isMobile || hideSidebar) && 'ml-0'
        )}
      >
        <Outlet />
      </main>
    </div>
  );
}
